export default {
  AS: {
    "footer.button.billOfMaterials": "Varaosalista",
    "footer.button.export": "Vienti",
    "footer.button.printPdf": "PDF",
    "footer.button.contactSales": "Jakelu Ota yhteyttä",
    "footer.button.addToWatchlist": "Lisää muistilistaan",
    "footer.button.requestQuote": "Pyydä tarjous",
    "header.configurator.title": "Konfiguraattori",

    "header.links.about.label": "Tietoa Asecosista",
    "header.links.about.url":
      "https://www.asecos.com/About-asecos/About-asecos/About-asecos/EN_index_3187.html,",
    "header.links.terms.label": "Yleiset ehdot",
    "header.links.terms.url":
      "https://www.asecos.com/GTS-asecos-AB/SE_index_1724.html,",
    "header.links.imprint.label": "Yritystiedot",
    "header.links.imprint.url":
      "https://www.asecos.com/Imprint/SE_index_1438.html,",
    "header.links.privacy.label": "Tietosuojakäytäntö",
    "header.links.privacy.url":
      "https://www.asecos-configurator.com/FI/FI/tietosuojaseloste",

    "dialog.requestQuote.title.success": "Kysely lähetetty",
    "dialog.requestQuote.title.requestQuote": "Pyydä tarjous",
    "tab.billOfMaterials.title": "Varaosalista",
    "tab.configurationSummary.title": "Yhteenveto konfiguraatiosta",
    "dialog.requestQuote.title.contactData": "Yhteystiedot",
    "dialog.requestQuote.title.companyData": "Yritystiedot",
    "dialog.requestQuote.label.salutation": "Arvostus",
    "dialog.requestQuote.select.salutation.option.female": "Rouva",
    "dialog.requestQuote.select.salutation.option.male": "Herra",
    "dialog.requestQuote.select.salutation.option.none": "--",

    "dialog.requestQuote.label.firstName": "Etunimi",
    "dialog.requestQuote.label.lastName": "Sukunimi",
    "dialog.requestQuote.label.email": "Sähköposti",
    "dialog.requestQuote.label.phone": "Puhelin",
    "dialog.requestQuote.label.company": "Yritys",
    "dialog.requestQuote.label.country": "Maa",
    "dialog.requestQuote.label.postalCode": "Postinumero",
    "dialog.requestQuote.label.city": "Paikkakunta",
    "dialog.requestQuote.label.street": "Katu",
    "dialog.requestQuote.label.number": "Nro",
    "dialog.requestQuote.label.contactHours": "Pyydän soittamaan takaisin",
    "dialog.requestQuote.checkbox.contactHours.option.morning": "Aamupäivä",
    "dialog.requestQuote.checkbox.contactHours.option.afternoon": "Iltapäivä",
    "dialog.requestQuote.label.specialistRetailer.header":
      "Jos sinulla on ensisijainen jälleenmyyjä, rekisteröi se tässä",

    "dialog.requestQuote.label.specialistRetailer.salutation": "Arvostus",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.female":
      "Rouva",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.male":
      "Herra",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.none":
      "--",
    "dialog.requestQuote.label.specialistRetailer.company": "Yritys",
    "dialog.requestQuote.label.specialistRetailer.firstName": "Etunimi",
    "dialog.requestQuote.label.specialistRetailer.lastName": "Sukunimi",
    "dialog.requestQuote.label.specialistRetailer.email": "Sähköposti",
    "dialog.requestQuote.label.specialistRetailer.city": "Paikkakunta",
    "dialog.requestQuote.url.privacyPolicy":
      "https://www.asecos-configurator.com/FI/FI/tietosuojaseloste",
    "dialog.requestQuote.url.consentForm":
      "https://www.asecos-configurator.com/EN/FI/media/DOK_EXT_Einwilligungserklaerung-asecos-Konfigurator_IN?sprache=EN",
    "dialog.requestQuote.label.readPrivacyPolicy":
      "Olen lukenut <privacyLink>tietosuojakäytännön</privacyLink> ja hyväksyn sen. Lisäksi annan suostumukseni tietojeni käsittelyyn, käyttöön ja luovuttamiseen erityisjälleenmyyjälle <consentLink>suostumuksen mukaisesti.</consentLink>",
    "dialog.requestQuote.label.comment": "Kommentti",
    "SubconfigurationNavigation.resetItem": "Tyhjennä valinnat",
    "SubconfigurationNavigation.previousItem": "Edellinen",
    "SubconfigurationNavigation.nextItem": "Seuraava",
    "form.field.error.email": "Sähköpostiosoite ei kelpaa",
    "form.field.error.phone": "Puhelinnumero ei kelpaa",
    "validation.required": "Tämä kenttä on pakollinen",
    "footer.button.save": "Tallenna",
    "footer.button.load": "Lataa",

    "dialog.requestQuote.success.message":
      "Kiitos kiinnostuksestasi asecosia ja tuotteitamme kohtaan. Saat muutaman minuutin kuluttua vahvistuksen antamaasi sähköpostiosoitteeseen, joka sisältää konfiguraatiotietosi PDF- ja JSON-tiedostona. Jälkimmäisen avulla voit avata konfiguraatiosi uudelleen latauspainikkeella. \n\nasecos-tuotteita myydään valtuutettujen jälleenmyyjien kautta. Siksi välitämme pyyntösi sopivalle asecos-kumppanille. Tämä laatii sinulle sitoumuksettoman tarjouksen konfiguraatiosi mukaisesti ja ottaa tarvittaessa sinuun yhteyttä.",
    "dialog.requestQuote.success.close": "Sulje",
    "dialog.requestQuote.error.message":
      "Pyyntösi lähettämisessä tapahtui virhe. Yritä myöhemmin uudelleen.",
  },
};
